import {ChangeDetectionStrategy, Component} from '@angular/core';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {DataSourceWarningMessageDialogComponent}
    from '../data-source-warning-message-dialog/data-source-warning-message-dialog.component';

@Component({
    selector: 'tart-date-source-error-message-dialog',
    templateUrl: './date-source-error-message-dialog.component.html',
    styleUrls: ['./date-source-error-message-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateSourceErrorMessageDialogComponent {
    title: string;
    message: string;
    warnings: string[];

    constructor(
        private dialogRef: NbDialogRef<any>,
        private dialogService: NbDialogService) {}

    close(): void {
        this.dialogRef.close();
    }

    showWarnings(): void {
        this.close();
        this.dialogService.open(DataSourceWarningMessageDialogComponent,
            {context: {warnings: this.warnings, title: 'به‌روزرسانی اجباری', type: 'updateDatasourceData'}});
    }
}
